export default __webpack_public_path__ + "static/media/Oasis.e2dbecce.jpg";